import app from './app'
import kansas from './kansas'
import texas from './texas'

export default {
  app,
  kansas,
  texas
}



// WEBPACK FOOTER //
// ./src/config/index.js